module.exports = __webpack_public_path__ + "static/img/cooperation_banner.3c862a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/cooperation_banner.png
// module id = zj/7
// module chunks = 1